import { ConfirmModal } from "src/hooks/modals/useConfirmModal";
import { VendorSetupAccount } from "src/hooks/modals/useVendorSetupAccount";
import { getDefaultAddress } from "src/util/user";
import { tVendorData } from "tmt_api/src/types/types.validator";
import { openModalAsync } from "../modals/actions";
import { tModalResponse } from "../modals/types";
import { tReduxAction } from "../types";

export const openConfirmModal = (): tReduxAction<Promise<tModalResponse<void>>> => {
  return (dispatch) => {
    return dispatch(
      openModalAsync(ConfirmModal, {
        title: "CONNECT YOUR BANK ACCOUNT",
        description:
          "Once your order is accepted & shipped by the brand, the credit redeemed will be deposited directly into your bank account.",
        confirmButtonLabel: "Connect Bank Account",
        hideCancelButton: true,
      }),
    );
  };
};

export const openRetailerVendorSetupAccountModal = (): tReduxAction<Promise<tModalResponse<void>>> => {
  return (dispatch, getState) => {
    const companyReducer = getState().CompanyReducer;
    const rRetailer = companyReducer.type === "retailer" ? companyReducer : null;
    const isSetupForRewards = !!rRetailer?.vendorId;
    const address = getDefaultAddress(rRetailer?.addresses ?? []);
    const defaultValue: tVendorData = {
      businessName: rRetailer?.name ?? "",
      businessDomain: rRetailer?.website ?? "",
      ein: rRetailer?.taxId ?? "",
      url: rRetailer?.website ?? "",
      emailAddress: rRetailer?.email ?? "",
      address1: address.address1,
      address2: address.address2 ?? "",
      city: address.city,
      state: address.state_or_province,
      zipCode: address.postal_code,
      phone: rRetailer?.phone ?? "",
      country: address.country_code,
      accountNumber: "",
      routingNumber: "",
    };
    return dispatch(
      openModalAsync(VendorSetupAccount, {
        mode: "retailer",
        defaultValue,
        isEditing: isSetupForRewards,
      }),
    );
  };
};
